import request from "../../utils/request";
export default {
  getImage: function getImage(type) {
    return request('get', 'api/d/v1/onlineBranch/getImage?type=' + type);
  },
  getImages: function getImages(type) {
    return request('get', 'api/d/v1/onlineBranch/getImages?type=' + type);
  }
};